import { countriesList, UUID } from '@cmg/common';
import { xcSelectors } from '@cmg/e2e-selectors';

import { useCheckSyndicateWiresAccess } from '../../../../../common/util/check-access/useCheckSyndicateWiresAccess';
import routeFactory from '../../../../../common/util/routeFactory';
import { ReactRouterDomainNavTabProps } from '../../../../../design-system/react-router/ReactRouterDomainNavTab';
import { OfferingType } from '../../../../../graphql';

type Props = {
  offeringId: UUID | undefined;
  isSharedDraft: boolean;
  offeringType: OfferingType | undefined;
  isDiscarded: boolean;
  offeringCountryCode?: string;
};

const UNSUPPORTED_OFFERING_TYPES = [OfferingType.UnregisteredBlock];

export const useSyndicateWiresRoute = ({
  offeringId,
  offeringType,
  isSharedDraft,
  isDiscarded,
  offeringCountryCode,
}: Props): ReactRouterDomainNavTabProps | undefined => {
  const { canRead } = useCheckSyndicateWiresAccess(offeringId);

  if (!offeringId) {
    return undefined;
  }

  if (offeringType && UNSUPPORTED_OFFERING_TYPES.includes(offeringType)) {
    return undefined;
  }

  if (isSharedDraft) {
    return undefined;
  }

  if (isDiscarded) {
    return undefined;
  }

  if (!canRead) {
    return undefined;
  }

  if (offeringCountryCode !== countriesList.Usa.countryCode) {
    return undefined;
  }

  return {
    'data-testid': xcSelectors.offeringNavBarSyndicateWires.testId,
    href: routeFactory.syndicateWires.getUrlPath({ offeringId }),
    label: 'Wires',
    value: 'wires',
  };
};
